import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

interface IProps {
  HeaderColorClass: string;
  HeaderIconClass?: string;
  Title: string;
  DescriptionIconClass?: string;
  DescriptionHTML: JSX.Element;
  MoreHTML?: JSX.Element;
}

const CpntCommunicationBloc: React.FC<IProps> = ({
  HeaderColorClass,
  HeaderIconClass,
  Title,
  DescriptionIconClass,
  DescriptionHTML,
  MoreHTML,
}) => {
  // const ProductCardHeader = (
  //   <div className={`pae-product-card-illu ${HeaderColorClass}`}>
  //     <p className="h3lpe mb-0">
  //       <i className={`bi ${HeaderIconClass}`}></i>
  //     </p>
  //   </div>
  // );
  //const ProductCardFooter = <hr style={{ width: "100px", margin: "auto" }} />;
  return (
    <>
    <Row xs={1}className="mt-1 g-4">
      <Col className="offset-lg-3 col-lg-6">
      <Card className="module-card">
          <Card.Header className={`text-start ${HeaderColorClass}`}>
          <i className="bi "></i>
          <i className={`bi ${HeaderIconClass ? HeaderIconClass : 'bi-app-indicator'}`}></i>
          </Card.Header>
          <Card.Body>
            <Card.Title>{Title}</Card.Title>
            <Card.Text className="description pt-2 row text-center">
              {DescriptionIconClass && <i className={`bi ${DescriptionIconClass}`}></i>}
              <p>{DescriptionHTML}</p>
            </Card.Text>
          </Card.Body>
          <Card.Footer>
            <Link to={`/accueil`} className="btn btn-secondary">Se connecter</Link>
          </Card.Footer>
        </Card>
      {/* <Card className="module-card card">
          <Card.Header className={`text-start ${HeaderColorClass}`}>
          <i className="bi bi-app-indicator"></i>
          </Card.Header>
          <Card.Body>
            <Card.Title>{Title}</Card.Title>
            <Card.Text className="description pt-2 row">
              <div>
                <i className={`bi ${HeaderIconClass}`}></i>
              </div>
              <div > 
                {DescriptionHTML}
              </div>
            </Card.Text>
          </Card.Body>
          <Card.Footer>
          <Link to={`/espaceediteur`} className="btn btn-secondary">Accéder</Link>
            </Card.Footer>
        </Card> */}
        {MoreHTML}
      </Col>
    </Row>
    </>
  );
};

export default CpntCommunicationBloc;
